import React, { useContext } from "react"
import LocaleContext from "../../../context/LocaleContext"
import translate, { keys } from "../../../translation/translator"
import ReviewsSliderWrapper from "./shared/reviewsSliderWrapper/ReviewsSliderWrapper"
import Review from "./shared/review/Review"
import ReviewsSliderWrapperStyle from "./shared/reviewsSliderWrapper/ReviewsSliderWrapperStyle.module.styl"

const ReviewsSlider = ({ images }) => {
  const locale = useContext(LocaleContext).locale
  const ReviewImageOne = images[1].node.childImageSharp.fluid
  const ReviewImageTwo = images[2].node.childImageSharp.fluid
  const ReviewImageThree = images[0].node.childImageSharp.fluid
  return (
    <ReviewsSliderWrapper>
      {" "}
      <div className={ReviewsSliderWrapperStyle.reviews_holder}>
        <Review
          to={translate(keys.INDEX_CALC_REWIEW_URL_I, locale)}
          name={translate(keys.INDEX_CALC_REWIEW_YI, locale)}
          image={ReviewImageOne}
          description={translate(keys.INDEX_CALC_REWIEW_YI_STORY, locale)}
        />
        <Review
          to={translate(keys.INDEX_CALC_REWIEW_URL_II, locale)}
          image={ReviewImageTwo}
          name={translate(keys.INDEX_CALC_REWIEW_JAY, locale)}
          description={translate(keys.INDEX_CALC_REWIEW_JAY_STORY, locale)}
        />
        <Review
          to={translate(keys.INDEX_CALC_REWIEW_URL_III, locale)}
          name={translate(keys.INDEX_CALC_REWIEW_IVET, locale)}
          description={translate(keys.INDEX_CALC_REWIEW_IVET_STORY, locale)}
          image={ReviewImageThree}
        />
      </div>
    </ReviewsSliderWrapper>
  )
}

export default ReviewsSlider
